import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { SharedFilesTable } from '../partials/SharedFilesTable';
import {
  SharedDirectory,
  SharedFile,
  SharedFilesDeleteForm,
  SharedFilesMoveForm,
  SharedFilesPrepareMultiDownloadUrl,
} from '../SharedFiles.types';
import { SonForm } from '../../../_lib/Form2';
import { SharedFilesUploadButton } from '../partials/SharedFilesUploadButton';
import { SharedFilesGlobalActions } from '../partials/SharedFilesGlobalActions';
import { SharedFilesSelectedItemsProvider } from '../context/SharedFilesSelectedItems';

type SharedFilesDefaultProps = {
  prepareMultiDownloadUrl: SharedFilesPrepareMultiDownloadUrl;
  files?: SharedFile[];
  directories?: SharedDirectory[];
  uploadForm?: SonForm<any>;
  moveForm?: SharedFilesMoveForm;
  deleteMultiForm?: SharedFilesDeleteForm;
};

/**
 * Shared files Default View.
 */
function SharedFilesDefault({
  files,
  directories,
  uploadForm,
  prepareMultiDownloadUrl,
  moveForm,
  deleteMultiForm,
}: SharedFilesDefaultProps) {
  return (
    <div className="shared-files">
      <SharedFilesSelectedItemsProvider>
        <div className="shared-files__table-top-container">
          <SharedFilesGlobalActions
            prepareMultiDownloadUrl={prepareMultiDownloadUrl}
            moveForm={moveForm}
            deleteForm={deleteMultiForm}
          />
          {uploadForm && <SharedFilesUploadButton uploadForm={uploadForm} />}
        </div>
        <SharedFilesTable files={files} directories={directories} />
      </SharedFilesSelectedItemsProvider>
    </div>
  );
}

export const SharedFilesDefaultView = asView(SharedFilesDefault);
export type SharedFilesDefaultView = ComponentProps<typeof SharedFilesDefaultView>;
